import Bugsnag from "@bugsnag/js";
import axios from "axios";

import { SET_COUNTRY_CODES } from "./types";

export const setCountryCodes = () => {
  return async dispatch => {
    try {
      const response = await axios.get(
        "https://s3.ap-southeast-1.amazonaws.com/assets.theinnerhour.com/country_codes/country-codes.json"
      );

      const countryCodes = response.data.filter(
        country => !!country.name && country.phone?.length > 0
      );

      dispatch({
        type: SET_COUNTRY_CODES,
        payload: countryCodes,
      });
    } catch (error) {
      Bugsnag.notify(error);
    }
  };
};
